/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type for text parameter type.
 */
export enum WhatsAppTemplateMessageTextParameterType {
    TEXT = 'text',
}
